import axios from 'axios'
import { Dispatch } from 'react'
import { CapSizeResponse } from '../types/UploadImages'
import { WizardAction, WizardState } from '../types/WigWizard'
import { ProductCustomizerState } from '../types/ProductCustomizer';

export async function UploadImages({ state, stateProductCustomizer, dispatch,setErrorMessage, email, redirectAfterLogin }: { state: WizardState,stateProductCustomizer: ProductCustomizerState, dispatch: Dispatch<WizardAction>, setErrorMessage: Function,email?: string, redirectAfterLogin?: string }): Promise<any> {
  console.log(stateProductCustomizer)

  let cardType=""
  let hairline=""

  for(let i=0; i<stateProductCustomizer.steps.length;i++){
    if(stateProductCustomizer.steps[i].id==="Card"){
      cardType=stateProductCustomizer.steps[i].options[stateProductCustomizer.selectedOptions[i]].id
    }
    else if(stateProductCustomizer.steps[i].id==="Hairline"){
      hairline=stateProductCustomizer.steps[i].options[stateProductCustomizer.selectedOptions[i]].id
    }
    
  }

  try {
    dispatch({ type: 'Uploading' })

    const { data: { cap_size, lace_tint, lace_tint_description, s3_bucket_folder } }: { data: CapSizeResponse } = await axios.post(
      `https://parfait-pro-api.com/api/ai/capsizelacetint/`,
      {
        image1: state.steps[0].img,
        image2: state.steps[1].img,
        image3: state.steps[2].img,
        image4: state.steps[3].img,
        hairline_type: hairline,
        card_type: cardType,
      })

    dispatch({ type: 'Uploaded', value: { cap_size, lace_tint, lace_tint_description, s3_bucket_folder, redirectAfterLogin, email } })
    return Promise.resolve()
  } catch (err) {
    setErrorMessage("THERE WAS AN ISSUE WHILE PROCESSING YOUR PHOTOS, PLEASE RETAKE THEM")
    dispatch({ type: 'Error', value: 'Error uploading photos. Please start over.' })
    return Promise.reject()
  }
}
